/* unplugin-vue-components disabled */import script from "./index.vue?vue&type=script&setup=true&name=Admin&lang=js"
export * from "./index.vue?vue&type=script&setup=true&name=Admin&lang=js"

import "./index.vue?vue&type=style&index=0&id=d8349e3c&lang=scss"

const __exports__ = script;

export default __exports__